import { type User, type UserResponse } from './auth';

export function UserAdapter(user: UserResponse): User {
  try {
    return {
      firstName: user.first_name,
      lastName: user.last_name,
      activeRideId: user.active_ride_id,
      activeRidePickupName: user.active_ride_pickup_name,
      todayRidesScheduleCount: user.today_rides_schedule_count,
      email: user.email,
      id: user.id,
    };
  } catch {
    throw new Error('Failed to adapt user response');
  }
}
